
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    CPNO: "CPNO",
    OEM: "OEM",
    PNO: "PNO",
    SPNO: "SPNO",
    REF: "REF",
    NSN: "NSN",
    STD: "STD"
};
